/**
 *缓存请求数据
 * 快码缓存例子：
 {
    data : [], // 缓存lookup数据
    effectTime: 1727574548328, // 生效时间戳
    field: "SCP_FG_SUPPLY_TYPE-{\"lookupType\":\"SCP_FG_SUPPLY_TYPE\",\"current\":1,\"pageSize\":999}", // 标记字段 = lookup类型-参数
    params: "{\"lookupType\":\"SCP_FG_SUPPLY_TYPE\",\"current\":1,\"pageSize\":999}" // 参数
  }
 **/
export default {
  state: {
    cacheDataVal: {} // 缓存数据
  },
  mutations: {
    setRequestCache(state, data) {
      state.cacheDataVal[data.field] = data
    },
    clearCacheDataItem(state, field) {
      delete state.cacheDataVal[field]
    },
    clearCacheData(state) {
      state.cacheDataVal = {}
    }
  }
}
